import { CustomTooltip } from '@/components/custom-tooltip';
import type { ICellRendererParams } from 'ag-grid-community';
import type { EventResponse } from 'graphql/gql-types';
import { useEventTooltip } from '../hooks/useEventTooltip';

interface EventTooltipProps {
	count: number;
	events: EventResponse[];
}

export const EventTooltip = ({ count, events }: EventTooltipProps) => {
	const { shouldShow, title, content } = useEventTooltip({ count, events });

	if (count === 0) {
		return <span>0</span>;
	}

	if (!shouldShow) {
		return <span>{count}</span>;
	}

	return (
		<CustomTooltip
			placement='bottom'
			backgroundColor='tw-bg-white'
			arrowColor='tw-fill-primary'
			arrow
			borderColor='tw-border-primary'
			content={
				<div
					className='event-tooltip'
					style={{ padding: '0.5rem', fontSize: '0.8rem', color: '#000' }}
				>
					<div
						style={{
							marginBottom: '0.25rem',
							fontWeight: '600',
							fontSize: '0.9rem',
							color: '#000',
						}}
					>
						{title}
					</div>
					<div
						style={{ whiteSpace: 'pre-line', lineHeight: '1.3', color: '#000' }}
					>
						{content}
					</div>
				</div>
			}
		>
			<span className='text-blue-600 font-medium underline decoration-dotted cursor-help'>
				{count}
			</span>
		</CustomTooltip>
	);
};

export const renderEventCell = (params: ICellRendererParams): JSX.Element => {
	const eventCount: number = params?.data?.event_count || 0;
	const events: EventResponse[] = params?.data?.events || [];

	return <EventTooltip count={eventCount} events={events} />;
};
